var _rect, _mask, _path, _path2, _g, _rect2, _rect3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLidJarOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.20728,
    y: 25.7598,
    width: 10.7681,
    height: 2.13815,
    rx: 0.5,
    fill: "#3B1F8E",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_43_24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1825 9C21.1825 8.44772 20.7348 8 20.1825 8H1C0.447715 8 0 8.44771 0 9V10.9227C0 11.475 0.447716 11.9227 1 11.9227H1.22774C1.7491 11.9227 2.18297 12.3232 2.22455 12.8429L3.23645 25.4917C3.27802 26.0114 3.7119 26.4119 4.23326 26.4119H16.9497C17.4711 26.4119 17.9049 26.0114 17.9465 25.4917L18.9584 12.8429C19 12.3232 19.4339 11.9227 19.9552 11.9227H20.1825C20.7348 11.9227 21.1825 11.475 21.1825 10.9227V9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1825 9C21.1825 8.44772 20.7348 8 20.1825 8H1C0.447715 8 0 8.44771 0 9V10.9227C0 11.475 0.447716 11.9227 1 11.9227H1.22774C1.7491 11.9227 2.18297 12.3232 2.22455 12.8429L3.23645 25.4917C3.27802 26.0114 3.7119 26.4119 4.23326 26.4119H16.9497C17.4711 26.4119 17.9049 26.0114 17.9465 25.4917L18.9584 12.8429C19 12.3232 19.4339 11.9227 19.9552 11.9227H20.1825C20.7348 11.9227 21.1825 11.475 21.1825 10.9227V9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9584 12.8429L17.9616 12.7632L18.9584 12.8429ZM3.23645 25.4917L2.23963 25.5714L3.23645 25.4917ZM1 9H20.1825V7H1V9ZM1 10.9227V9H-1V10.9227H1ZM1.22774 10.9227H1V12.9227H1.22774V10.9227ZM4.23326 25.4119L3.22137 12.7632L1.22774 12.9227L2.23963 25.5714L4.23326 25.4119ZM16.9497 25.4119H4.23326V27.4119H16.9497V25.4119ZM17.9616 12.7632L16.9497 25.4119L18.9433 25.5714L19.9552 12.9227L17.9616 12.7632ZM20.1825 10.9227H19.9552V12.9227H20.1825V10.9227ZM20.1825 9V10.9227H22.1825V9H20.1825ZM20.1825 12.9227C21.2871 12.9227 22.1825 12.0273 22.1825 10.9227H20.1825V10.9227V12.9227ZM19.9552 12.9227V10.9227C18.9125 10.9227 18.0447 11.7238 17.9616 12.7632L19.9552 12.9227ZM16.9497 27.4119C17.9924 27.4119 18.8602 26.6108 18.9433 25.5714L16.9497 25.4119V27.4119ZM2.23963 25.5714C2.32279 26.6108 3.19054 27.4119 4.23326 27.4119V25.4119H4.23326L2.23963 25.5714ZM1.22774 12.9227L3.22137 12.7632C3.13821 11.7238 2.27046 10.9227 1.22774 10.9227V12.9227ZM-1 10.9227C-1 12.0273 -0.104569 12.9227 1 12.9227V10.9227H1H-1ZM20.1825 9V9H22.1825C22.1825 7.89543 21.2871 7 20.1825 7V9ZM1 7C-0.104569 7 -1 7.89543 -1 9H1V9V7Z",
    fill: "black",
    mask: "url(#path-2-inside-1_43_24)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 31.5082C22.7614 31.5082 25 29.2696 25 26.5082C25 23.7468 22.7614 21.5082 20 21.5082C17.2386 21.5082 15 23.7468 15 26.5082C15 29.2696 17.2386 31.5082 20 31.5082Z",
    fill: "#0C995E",
    stroke: "#0C995E",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 26.5082L19.5 27.5082L21.5 25.5082",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.85358,
    width: 20.1825,
    height: 2.92269,
    rx: 0.5,
    fill: "#3B1F8E",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.56091,
    y: 2.5,
    width: 6.06084,
    height: 2.13815,
    rx: 0.5,
    fill: "white",
    stroke: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_43_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11C22.7614 11 25 8.76142 25 6C25 3.23858 22.7614 1 20 1C17.2386 1 15 3.23858 15 6C15 8.76142 17.2386 11 20 11Z",
    fill: "#0C995E",
    stroke: "#0C995E",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6L19.5 7L21.5 5",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(14 20.5082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_43_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLidJarOn);
export default __webpack_public_path__ + "static/media/lidJarOn.fe304bbd6f5b61782a21810706e7e9e7.svg";
export { ForwardRef as ReactComponent };